import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faThumbtack } from '@fortawesome/pro-light-svg-icons';

export type ProLightThumbtackProps = IconComponentProps;

export const ProLightThumbtack = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightThumbtackProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faThumbtack}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faThumbtack}
    />
  );
};

ProLightThumbtack.displayName = 'ProLightThumbtack';
